import { Button } from '@augmentt-dev/ui-components'
import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import { getSelectedCustomerId } from '../../../../../../../_augmentt/selectors/customers'
import useAuthorization from '../../../../../../hooks/useAuthorization'
import { SettingsModalVisibilityContext } from '../../../default-settings/SettingsModalsVisibilityProvider'

const propTypes = {
  /**
   * type (action) of the modal, defined in DEFAULT_SETTINGS_ACTIONS
   */
  modalAction: PropTypes.string.isRequired, // eslint-disable-line react/forbid-prop-types
  /**
   * FormattedMessage id, label to show on the back button on the top of the modalto be opened, e.g. 'Back to offboarding'
   */
  headerBackButtonLabel: PropTypes.string.isRequired, // eslint-disable-line react/forbid-prop-types
}

/**
 * Button to open a specific default settings modal
 */
function OpenSettingsButton(props) {
  const { modalAction, headerBackButtonLabel } = props

  const { isAuthorizedForEngageAutopilot } = useAuthorization()

  const { openSettingsModal } = useContext(SettingsModalVisibilityContext)

  const selectedCustomerId = useSelector(getSelectedCustomerId)

  if (!isAuthorizedForEngageAutopilot) {
    return null
  }

  return (
    <Button
      variant="link"
      className="p-0"
      onClick={() =>
        openSettingsModal({
          modalAction,
          initialSetupCompany: selectedCustomerId,
          headerBackButtonLabel,
        })
      }
    >
      <i className="fas fa-gear me-2" />
      <FormattedMessage id="DEFAULT_SETTINGS.DEFAULT_SETTINGS" />
    </Button>
  )
}

OpenSettingsButton.propTypes = propTypes

export default OpenSettingsButton
